import React, { useMemo } from 'react';

import { Grid, Card, CardContent, CardHeader } from '@gogame/components';
import { FormField, FormFieldGroup } from '@gogame/form';

import {
  loadFraudProtectionCountries,
  loadFraudProtectionDeviceTypes,
} from 'scenes/Campaigns/sources/fields';

import {
  FRAUD_PROTECTION_COUNTRIES,
  FRAUD_PROTECTION_DEVICE_TYPE,
  FRAUD_PROTECTION_OS_VERSION,
} from '../constants';
import { OsVersion } from './OsVersion';
import { getFraudDependencies } from './dependencies';
import { fraudProtectionSchema } from './schema';

// install only

export const FraudProtection = ({
  title,
  name,
  open,
  withOsVersion,
  withDeviceType,
  disabledDeviceType,
  disabled,
}) => {
  const dependencies = useMemo(() => getFraudDependencies(), []);

  return (
    <Card elevation={6}>
      <CardHeader title={title} />
      <CardContent>
        <FormFieldGroup
          name={name}
          validationSchema={open ? fraudProtectionSchema : undefined}
        >
          <Grid item xs={12}>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <FormField.MultiSelect
                  name={FRAUD_PROTECTION_COUNTRIES}
                  source={loadFraudProtectionCountries}
                  label={'Countries'}
                  padding={'0'}
                  disabled={disabled}
                  required={true}
                  validate={(v) => {
                    return !v?.length ? 'At least 1 county is required' : '';
                  }}
                />
              </Grid>
              {withDeviceType ? (
                <Grid item xs={6}>
                  <FormField.Select
                    name={FRAUD_PROTECTION_DEVICE_TYPE}
                    source={loadFraudProtectionDeviceTypes}
                    label={'Device type'}
                    padding={'0'}
                    withDeselectButton={true}
                    depends={
                      !disabledDeviceType
                        ? dependencies[FRAUD_PROTECTION_DEVICE_TYPE]
                        : undefined
                    }
                    disabled={disabledDeviceType || disabled}
                  />
                </Grid>
              ) : null}
              {withOsVersion ? (
                <Grid item xs={12}>
                  <OsVersion
                    name={FRAUD_PROTECTION_OS_VERSION}
                    dependencies={dependencies}
                    disabled={disabled}
                  />
                </Grid>
              ) : null}
            </Grid>
          </Grid>
        </FormFieldGroup>
      </CardContent>
    </Card>
  );
};

export default FraudProtection;
